import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  container: {
    background: '#FFF',
    paddingTop: '100px',
    [theme.breakpoints.down('sm')]: {
      paddingTop: '20px',
    },
  },
  title: {
    fontFamily: 'Open Sans, sans-serif',
    fontWeight: '600',
    fontSize: '2rem',
    lineHeight: '2.5rem',
    textAlign: 'center',
    color: '#000',
    [theme.breakpoints.up('sm')]: {
      fontSize: '4rem',
      lineHeight: '4.5rem',
    },
  },
  containerCredit: {
    width: '100%',
  },
  innerContatiner: {
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  subTitle: {
    marginTop: '60px',
    marginBottom: '10px',
    fontFamily: 'Open Sans, sans-serif',
    fontWeight: '700',
    fontSize: '32px',
    lineHeight: '36px',
    textAlign: 'center',
    color: '#2c1482',
    [theme.breakpoints.up('sm')]: {
      fontSize: '32px',
      marginTop: '60px',
      marginBottom: '10px',
      lineHeight: '2.5rem',
    },
  },
  sliderContainer: {
    marginTop: '10px',
    marginBottom: '100px',
    [theme.breakpoints.up('sm')]: {
      fontSize: '32px',
      marginTop: '60px',
      marginBottom: '60px',
      lineHeight: '2.5rem',
    },
  },
}));
